/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type InstagramAccountStatus = typeof InstagramAccountStatus[keyof typeof InstagramAccountStatus];


export const InstagramAccountStatus = {
  active: 'active',
  expired: 'expired',
  revoked: 'revoked',
} as const;
